import { render, staticRenderFns } from "./ServicesHairAndMakeup.vue?vue&type=template&id=4066903a&lang=pug&"
import script from "./ServicesHairAndMakeup.vue?vue&type=script&lang=ts&"
export * from "./ServicesHairAndMakeup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports